import dispatchEvent from '../utils/dispatch-event.js';
import { addToCart } from '../modules/cart.js';

class ProductAddToCartButton extends HTMLElement {
  constructor() {
    super();

    this.atc = this.querySelector('[data-atc-btn]');
    this.atc.disabled = true;

    setTimeout(() => {
      this.atc.disabled = false;
    }, 1000);

    this.atc.addEventListener('click', event => {
      event.preventDefault();

      const { id } = JSON.parse(this.atc.dataset.productVariant);

      this.atc.textContent = window.translations.product.pdp.form.addingToBag;

      addToCart(
        {
          items: [
            {
              id,
              quantity: 1,
            },
          ],
        },
        {
          element: this.atcButton,
          eventOptions: {
            detail: { action: 'open-cart' },
          },
        }
      ).then(() => dispatchEvent('cart:quantity-updated', document));
    });

    document.addEventListener('cart:rerendered', () => {
      this.atc.textContent = window.translations.product.pdp.form.addToCart;
    });
  }
}

customElements.define('product-atc', ProductAddToCartButton);
